'use strict';

export const RegEx = {
    // https://emailregex.com
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    // phone number (e.g. (123) 456-7890)
    phone: /^(?:\(\d{3}\)|\d{3})[- ]?\d{3}[- ]?\d{4}$/,
    // phone digits with international code
    number: /^\+[1](\d{3})(\d{3})(\d{4})$/,
    // sln as 5 digits (e.g. 12345)
    sln: /^\d{5}$/,
    // time range (e.g. 12:00 am - 12:00 pm)
    timeRange: /^(1[0-2]|0?[1-9]):[0-5][0-9]\s?[apmAPM]{2}\s?\W\s?(1[0-2]|0?[1-9]):[0-5][0-9]\s?[apmAPM]{2}$/
};

/**
 * Restricts input field to the maxlength value on the input.
 * @param e The onInput js event
 * @return true if the value length is less then or equal to maxlength, else ignore any attempt to input more than the maxlength
 */
export function handleInputMaxLength(e) {
    let value = e.target.value;
    if ( value.length <= e.target.maxLength ) {
        return true;
    } else {
        e.target.value = value.substring(0, value.length - 1);
    }
}

/**
 * Restricts input field to just digits and select/copy/cut/paste/tab/esc/arrow actions
 * @param e The js event from keydown
 * @return true if key is allowed, if not, then preventDefault
 */
export function handleInputNumbersOnly(e) {
    // Is the keydown a copy, cut, paste, or select all action
    let charCode = String.fromCharCode(e.which).toLowerCase();
    let isAllowedAction = ( (e.ctrlKey || e.metaKey) && ['a', 'x', 'c', 'v'].includes(charCode));
    // Is the keydown a digit, backspace, esc, left or right arrow, or other ctrl/cmd key
    let isAllowedCode = [0, 8, 9, 17, 27, 37, 39, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 91, 93, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105].includes(e.which);
    // If the keydown is an allowed action or allowed key, continue, if not prevent default
    if ( isAllowedCode || isAllowedAction ) {
        return true;
    } else {
        e.preventDefault();
    }
}

export function numberInputOnWheelPreventChange(e) {
    // Prevent the input value change
    e.target.blur()
    // Prevent the page/container scrolling
    e.stopPropagation()
    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
        e.target.focus()
    }, 0);
}

/**
 * Function to validate if a value contains all digits and an option test the length is a certain amount.
 * @param value - the string to test for all digits
 * @param length - optional number for testing if the length of provided value is a set length
 * @returns {boolean}
 */
export function isDigits(value, length) {
    if (value) {
        let isNumbers = /^\d+$/.test(value.toString());
        if (length) {
            return (value.toString().length === length && isNumbers);
        } else {
            return isNumbers;
        }
    } else {
        return false;
    }
}
